import styles from "./bubble.css.js";

/**
 * Renders a bubble component containing the specified text.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.text - The text to be displayed inside the bubble. If no text is provided, the component returns null.
 * @return {JSX.Element|null} The bubble component containing the text or null if no text is provided.
 */
export function Bubble({ text, topRight = true }) {
  if (!text) return null;
  return <div className={styles.bubble({ topRight })}>{text}</div>;
}
